<template>
  <validation-observer ref="refFormObserver">
    <b-row class="mx-0">
      <b-col cols="6">
        <validation-provider #default="validationContext" name="Unit">
          <b-form-group
            class="text-capitalize"
            :label="$tc('unit.title', 2)"
            label-for="id_unit"
            :state="getValidationState(validationContext)"
          >
            <select-paginate
              v-model="itemEdit.id_unit"
              :items="unitOptions"
              input-id="id_unit"
              :multiple="true"
              @change="updateDeviceTags"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider #default="validationContext" name="Center">
          <b-form-group
            class="text-capitalize"
            :label="$tc('centers.title', 1)"
            label-for="id_center"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemEdit.id_center"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="centerOptions"
              :reduce="(val) => val.value"
              input-id="id_center"
              @input="changeCenter"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider #default="validationContext" name="Sector">
          <b-form-group
            label="Sector"
            label-for="id_sector"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemEdit.id_sector"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sectorOptions"
              :reduce="(val) => val.value"
              input-id="id_sector"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <b-form-group
          label="Reseller"
          label-for="id_reseller">
          <v-select
            v-model="itemEdit.id_reseller"
            :options="resellersOptions"
            input-id="id"
            label="name"
            :reduce="(val) => val.id"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { onMounted,ref } from "@vue/composition-api";
import SelectPaginate from "../../../components/SelectPaginate.vue";
import store from "@/store";

export default {
  components: {
    SelectPaginate,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  props: {
    centerOptions: {
      type: Array,
      default: []
    },
    itemEdit: {
      type: Object
    },
    unitOptions: {
      type: Array,
      default: []
    },
    sectorOptions: {
      type: Array,
      default: []
    }
  },
  setup (props) {
    //HOOKS
    onMounted(async () => getResellers());

    //COMPOSABLES
    const { refFormObserver, getValidationState } = formValidation();

    //DATA
    const resellersOptions = ref([]);

    //METHODS
    const changeCenter = async () => {
      await store
        .dispatch("sector/getAll", {
          id_center: [itemData.value.id_center],
        })
        .then(() => {
          const sector = props.sectorOptions.filter(
            (item) => item.value == itemData.value.id_sector
          )

          if (sector.length == 0) itemData.value.id_sector = ""
        })
    }

    const getResellers = async () => {
     await store.dispatch("omniview_reseller/getAll", {
        q: '',
        max: 100,
        "page[n]": 1,
        sortBy: 'id',
        sortDesc: true,
      })
      .then((response) => {
        resellersOptions.value = response.data;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans["messages.error.server_error"],
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
    }

    const updateDeviceTags = () => {
      if (props.itemEdit.id_unit.length > 0) {
        const idTenants = props.itemEdit.id_unit.map((unit) => unit.id_tenant);
        store.dispatch("tenant/getDeviceTagsByTenantIds", { id_tenants: idTenants });
      }
    }

    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Validation observer is not initialized");
        return false;
      }
      const validation = await refFormObserver.value.validate();
      return validation;
    }

    return {
      getValidationState,
      refFormObserver,

      resellersOptions,

      withPopper: popperHelper.withPopper,

      changeCenter,
      updateDeviceTags,
      validateStep
    }
  }
}
</script>
